import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Grid, TextField, Typography } from '@material-ui/core';
import Theme from '../ui/Theme';
import Search from '../../assets/Search';
import PlanCard from './PlanCard';
import ShowProgress from '../ui/Backdrop';
import { showProgress, getPlanAssignedJourneys } from '../../redux/actions/DealershipActions';
import Service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import Image from '../common/Image';
import PlayIcon from '../../assets/PlayIcon';
import MikeIcon from '../../assets/MikeIcon';
import File from '../../assets/File';
import Article from '../../assets/Article';
import { ErrorToast, formateDate } from '../utils/Utils';
import ZeroState from '../common/ZeroState';
import EmptyFolder from '../../assets/EmptyFolder';

const useStyles = makeStyles(() => ({
  leftBarTitleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    padding: '2px 15px 15px 15px',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  leftBarTitleSubText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    marginLeft: '2px',
    color: Theme.palette.primary.main,
  },
  leftPane: {
    width: '100%',
    height: '70vh',
    border: '1px solid #F4F4F4',
    boxShadow: '4px 4px 16px rgba(0, 0, 0, 0.08)',
  },
  leftPaneTitleFrame: {
    padding: '12px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  searchFrame: {
    width: '100%',
    height: '42px',
    left: 'calc(50% - 440px/2)',
    marginTop: '12px',
    background: '#FAFAFA',
    border: '1px solid #F4F4F4',
    boxSizing: 'border-box',
  },
  searchStyle: { padding: '10px' },
  journeyFrame: {
    padding: '12px',
    height: '70%',
    overflowY: 'auto',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },

  journeySubTitleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  storyContainer: {
    borderBottom: '1px solid #E4E7EC',
    height: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    width: '70%',
    height: '70px',
    padding: '2px 8px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  info: {
    width: '25%',
    height: '70px',
    padding: '2px 5px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  story: {
    height: '70px',
    width: '98%',
    display: 'flex',
  },
  title: {
    color: '#10182B',
    fontSize: '15px',
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
  subText: {
    color: '#667085',
    fontSize: '12px',
  },
}));

const RightPlanContent = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const planDetails = useSelector((state) => state.getPlanDetails.plandetails);
  const planassignedJourneys = useSelector((state) => state.getPlanAssignedJourneys.planassignedJourneys);

  const [assignedJourneys, setAssignedJourneys] = useState([]);
  const [searchVal, setSearchVal] = useState('');
  const [filterArray, setFilterArray] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [storyList, setStoryList] = useState([]);
  const [filterStory, setFilterStory] = useState([]);
  const [searchStoryVl, setSearchStoryVl] = useState('');

  useEffect(() => {
    setAssignedJourneys(planassignedJourneys);
    setFilterArray(planassignedJourneys);
  }, [planassignedJourneys]);

  useEffect(() => {
    setFilterStory(storyList);
  }, [storyList]);

  useEffect(() => {
    if (planDetails?.id) {
      getJourneys(planDetails.id);
      getStories(planDetails.id);
    }
    setSearchStoryVl('');
    setSearchVal('');
  }, [planDetails]);

  const getJourneys = async (id) => {
    dispatch(showProgress(true));
    await Service.get(apiEndpoints.PLAN_JOURNEY.replace('ID', id), '')
      .then((response) => {
        setAssignedJourneys([...response]);
        setFilterArray([...response]);
        dispatch(getPlanAssignedJourneys('fetch', [...response]));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showProgress(false));
      });
  };
  const handleSearchChange = (e) => {
    const input = e.target.value;
    if (activeTab === 0) {
      setSearchVal(input);
      const filteredArray = input
        ? assignedJourneys?.filter((item) => item.title.toLowerCase().includes(input.toLowerCase()))
        : assignedJourneys;
      setFilterArray(filteredArray);
    } else {
      setSearchStoryVl(input);
      const filteredArray = input
        ? storyList?.filter((item) => item.title.toLowerCase().includes(input.toLowerCase()))
        : storyList;
      setFilterStory(filteredArray);
    }
  };

  const getStoryIcon = (type) => {
    switch (type) {
      case 'VIDEO':
        return <PlayIcon />;
      case 'PODCAST':
        return <MikeIcon />;
      case 'ROCKED_ARTICLE':
        return <File />;
      case 'ARTICLE':
        return <Article />;
      default:
        return '';
    }
  };

  const getStories = async (id) => {
    dispatch(showProgress(true));
    try {
      const res = await Service.get(apiEndpoints.PLAN_STORY.replace('ID', id));
      setStoryList(res || []);
    } catch (error) {
      ErrorToast(error);
    }

    dispatch(showProgress(false));
  };

  const getZeroScreen = (txt) => (
    <Grid
      style={{
        paddingTop: '70px',
      }}
    >
      <ZeroState Icon={EmptyFolder} text={txt} cardWidth="70%" bg="#F9FAFB" />
    </Grid>
  );

  return (
    <div>
      <Grid container direction="column" className={classes.leftPane}>
        <Grid item>
          <Grid container direction="row" className={classes.leftPaneTitleFrame}>
            <Grid>
              <Grid
                item
                className={classes.leftBarTitleText}
                onClick={() => setActiveTab(0)}
                style={
                  activeTab === 0
                    ? { borderBottom: '3px solid #622FEE', color: '#622FEE' }
                    : { borderBottom: '3px solid transparent', color: '#000000' }
                }
              >
                {assignedJourneys ? `Assigned Journeys (${assignedJourneys?.length})` : 'Assigned Journeys (0)'}
              </Grid>
            </Grid>
            <Grid>
              <Grid
                item
                className={classes.leftBarTitleText}
                onClick={() => setActiveTab(1)}
                style={
                  activeTab === 1
                    ? { borderBottom: '3px solid #622FEE', color: '#622FEE' }
                    : { borderBottom: '3px solid transparent', color: '#000000' }
                }
              >
                {storyList?.length > 0 ? `Stories (${storyList?.length})` : 'Stories (0)'}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="row" className={classes.searchFrame} justifyContent="start" alignItems="center">
            <Grid item className={classes.searchStyle}>
              <Search />
            </Grid>
            <Grid item style={{ width: '80%' }}>
              {activeTab === 0 ? (
                <TextField
                  id="searchId"
                  name="search"
                  required
                  autoComplete="off"
                  autoSave="off"
                  onChange={handleSearchChange}
                  placeholder="Search for Journey"
                  value={searchVal}
                  InputProps={{
                    disableUnderline: true,
                    className: classes.searchText,
                  }}
                  rows={1}
                />
              ) : (
                <TextField
                  id="searchId"
                  name="search"
                  required
                  autoComplete="off"
                  autoSave="off"
                  placeholder="Search for Story"
                  value={searchStoryVl}
                  onChange={handleSearchChange}
                  InputProps={{
                    disableUnderline: true,
                    className: classes.searchText,
                  }}
                  rows={1}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item className={classes.journeyFrame}>
          {activeTab === 0 ? (
            <Grid container direction="column">
              {filterArray?.length >= 1 ? (
                <Grid item>
                  {filterArray?.map((val) => (
                    <PlanCard textVal={val.title} subTextVal={`ID: ${val.id}`} />
                  ))}
                </Grid>
              ) : (
                getZeroScreen(
                  assignedJourneys?.length === 0 ? 'No journeys have been added to this plan yet' : 'No Results Found',
                )
              )}
            </Grid>
          ) : (
            <Grid container direction="column" style={{ gap: '5px' }}>
              {filterStory?.length >= 1
                ? filterStory?.map((item) => (
                    <Grid className={classes.storyContainer} key={item.id}>
                      <Grid className={classes.story}>
                        <Grid style={{ width: '25%', height: '70px' }}>
                          <Image
                            alt="logo"
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                            src={item.thumbnail}
                          />
                        </Grid>
                        <Grid className={classes.content}>
                          <Typography className={classes.title}>{item.title}</Typography>
                          <Typography className={classes.subText}>{item.instructor}</Typography>
                        </Grid>
                        <Grid className={classes.info}>
                          <Typography className={classes.subText}>{formateDate(item.publish_date)}</Typography>
                          <Typography className={classes.subText}>{getStoryIcon(item.type)}</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))
                : getZeroScreen(
                    storyList?.length === 0 ? 'No stories have been added to this plan yet' : 'No Results Found',
                  )}
            </Grid>
          )}
        </Grid>
      </Grid>
      <ShowProgress />
    </div>
  );
};

export default RightPlanContent;
